import { useEffect, useState } from "react";
import { fetchLatestApps } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function LatestApps () {

    const [appsNew, setAppRecommended] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
    fetchLatestApps()
        .then((data) => {
        setAppRecommended(Array.isArray(data) ? data : []);
        })
        .catch((error) => console.error("Error fetching recommended apps:", error))
        .finally(() => setLoading(false));
    }, []);

    // ✅ Normalize rating between 0–5
    const parseRating = (r) => {
    if (r === null || r === undefined || r === "") return 0;
    const n = typeof r === "number" ? r : Number(String(r).replace(",", "."));
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(5, n));
    };

    // ✅ Render star icons dynamically
    const renderStars = (rawRating) => {
    const rating = parseRating(rawRating);
    const totalStars = 5;
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.5 && fullStars < totalStars;
    const stars = [];

    for (let i = 0; i < totalStars; i++) {
        if (i < fullStars) stars.push(<span key={i}>★</span>);
        else if (i === fullStars && halfStar) stars.push(<span key={i}>⯨</span>);
        else stars.push(<span key={i}>☆</span>);
    }

    return <span className="stars">{stars}</span>;
    };

    if (loading)
    return (
        <div style={styles.loaderContainer}>
            <div style={styles.spinner}></div>
        </div>
    );
    return (
        <main className="main-content">
            <section className="section">
                <div className="section-header">
                <h2 className="section-title">New & updated apps</h2>
                </div>

                <div className="games-grid">
                {appsNew.length > 0 ? (
                    appsNew.map((app) => {
                    const ratingNum = parseRating(app.rating);
                    return (
                        <Link
                        to={`/app/details/${app.slug}`}
                        className="game-card"
                        key={app.id}
                        style={{ textDecoration: "none" }}
                        >
                        <div
                            className="game-image"
                            style={{
                            background: "linear-gradient(45deg, #fa709a, #fee140)",
                            backgroundImage: `url(${
                                app.feature_graphic_url
                                ? app.feature_graphic_url
                                : app.icon_url
                            })`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            }}
                        >
                            <div
                            className="game-icon"
                            style={{
                                backgroundImage: `url(${app.icon_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                            ></div>
                        </div>

                        <div className="game-info">
                            <div className="game-title">{app.name}</div>
                            <div className="game-developer">{app.developer}</div>
                            <div className="game-rating">
                            {renderStars(ratingNum)}
                            <span className="rating-text">{ratingNum.toFixed(1)}</span>
                            </div>
                        </div>
                        </Link>
                    );
                    })
                ) : (
                    <p>No apps in this section.</p>
                )}
                </div>
            </section>
        </main>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
    textAlign: "center",
  },
  noPosts: {
    textAlign: "center",
    padding: "40px 20px",
    fontSize: "18px",
    color: "#666",
  },
};

// Inject global CSS once (safe for dev/hmr)
const GLOBAL_STYLE_ID = "devpage-global-styles";
if (typeof document !== "undefined" && !document.getElementById(GLOBAL_STYLE_ID)) {
  const css = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .stars span {
      color: #FFD700;
      font-size: 1rem;
      margin-right: 1px;
      line-height: 1;
    }
    .game-rating { display: flex; align-items: center; gap: 8px; }
    .rating-text { font-size: 0.9rem; color: #333; }
  `;
  const styleEl = document.createElement("style");
  styleEl.id = GLOBAL_STYLE_ID;
  styleEl.innerHTML = css;
  document.head.appendChild(styleEl);
}

export default LatestApps;